/** @format */

import { toRegexp, toPath } from "@riotjs/route";
import textarea from "@tags/pages/inputs/textarea.riot";
import upload from "@tags/pages/inputs/upload.riot";
import registered from "@tags/pages/inputs/registered.riot";
import accept from "@tags/pages/histories/accept.riot";
import items from "@tags/pages/results/items.riot";
import duplication from "@tags/pages/results/duplication.riot";
import similarity from "@tags/pages/results/similarity.riot";
import settingStatus from "@tags/pages/setting/status.riot";
import settingNoticemail from "@tags/pages/setting/noticemail.riot";
import settingInfo from "@tags/pages/setting/info.riot";
import settingResigned from "@tags/pages/setting/resigned.riot";

const pages = [
  {
    path: "/setting/resigned",
    is: "setting-resigned",
    component: settingResigned,
  },
  {
    path: "/setting/info",
    is: "setting-info",
    component: settingInfo,
  },
  {
    path: "/setting/status",
    is: "setting-status",
    component: settingStatus,
  },
  {
    path: "/setting/noticemail",
    is: "setting-noticemail",
    component: settingNoticemail,
  },
  {
    path: "/inputs/textarea",
    is: "textarea-page",
    component: textarea,
  },
  {
    path: "/inputs/textarea/registered",
    is: "textarea-registered-page",
    component: registered,
  },
  {
    path: "/inputs/upload",
    is: "upload-page",
    component: upload,
  },
  {
    path: "/inputs/upload/registered",
    is: "upload-registered-page",
    component: registered,
  },
  {
    path: "/histories/accept/:page?",
    is: "accept-page",
    component: accept,
  },
  {
    path: "/results/items/:analyticId",
    is: "items-page",
    component: items,
  },
  {
    path: "/results/duplication/:analyticId/:targetId",
    is: "duplication-page",
    component: duplication,
  },
  {
    path: "/results/similarity/:analyticId/:targetId",
    is: "similarity-page",
    component: similarity,
  },
];

for (const page of pages) {
  page.route = toRegexp(page.path, [], { endsWith: "([#?].*)?" });
}

const routes = {
  pages,
  makePath: (name, param) =>
    toPath(pages.find((v) => v.is == name).path, param),
};

export default routes;
